import React,{ useEffect, useState } from "react";
import "./navbar.css";

// IMAGE IMPORTING

// import Logo from "../../assets/img/logo.svg";
import Logo from "../../assets/img/logo-og.png";
import { User} from "../../actions";

import DropIcon from "../../assets/icon/dropdown.svg";
import RightIcon from "../../assets/icon/R-arrow.svg";
import RegisterView from "../../views/register/RegisterView";
import Logout from "../../components/logout/Logout";
import { useSelector, useDispatch } from "react-redux";
import image from '../../utilities/constants.json'
import {userDetails,userLogout} from "../../services/MainApiDetails";

const Navbar = () => {
  const [openDropMenu, setOpenDropMenu] = useState(false);
  const isLogin = useSelector((state) => state.isLogged);
  const userProfile= useSelector((state) => state.userData.items);
  const [proImage,setProImage ]= useState(image.profile_image)
  const dispatch = useDispatch();

  useEffect(() => {
    getUserDetails();
  }, []);

  function getUserDetails()
  {

    if (userProfile.length  == 0 && localStorage.webKey)
    {

      userDetails().then((response)=>{
        if (response.data.status === 1) {

          dispatch(User(response.data.user_data))
          console.log(userProfile)
        }
      })
    }

  }
  function logoutUser() {
    userLogout().then((res)=>{
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/";
    }).catch((e)=>{
      console.log(e)
    })

  }

  function openDropMenuBar() {
    setOpenDropMenu(!openDropMenu);
  }

  return (
    <div className="navbar">
      <div className="container">
        <div className="navbar-wrapper">
          {/* <div className="navbar-topSection"> */}
          <div className="navbar-left">
            <div className="navbar-logo">
              <img src={Logo} alt="" />
            </div>
            <div className="navbar-title">
              {/* <h4>WORLDCUP PREDICTION</h4> */}
            </div>
          </div>
          <div className="navbar-right">
            {(localStorage.webKey || isLogin)? (
              <div className="navbar-drop">
                <div className="navbar-dropdown">
                  <div className="user-img">

                    <img src={userProfile.image?proImage+userProfile.image:'/static/media/avatar-face.43ebe3233b34365dc7a5.jpg'} alt="" />
                  </div>
                  <div className="user-name">{userProfile.name}</div>
                  <div className="drop-icon">
                    <img src={DropIcon} alt="" onClick={openDropMenuBar} />
                  </div>
                </div>
              </div>
            ) : (
              <div className="navbar-drop">
                <div className="navbar-dropdown">
                  {/* <div className="user-img">
                    <img src={User} alt="" />
                  </div> */}
                  <div className="user-name">
                    <a href={'/mobile-login'} className="btn" >LOGIN</a>
                  </div>
                  {/* <div className="drop-icon">
                    <img src={DropIcon} alt="" />
                  </div> */}
                </div>
              </div>
            )}

            <div className="navbar-mob-title">
              <h3>WORLDCUP</h3>
              <h3>PREDICTION</h3>
            </div>

            {openDropMenu === true ? (
              <div className="navbar-dropmenu-wrapper">
                <div className="navbar-dropmenu-items">
                  <div className="dropmenu-icon">
                    {/* <img src="" alt="" /> */}
                  </div>
                  <div className="dropmenu-text">Predictions</div>
                  <div className="dropmenu-rightIcon">
                    <img src={RightIcon} alt="" />
                  </div>
                </div>
                <div className="navbar-dropmenu-items">
                  <div className="dropmenu-icon">
                    {/* <img src="" alt="" /> */}
                  </div>
                  <div className="dropmenu-text">Prizes</div>
                  <div className="dropmenu-rightIcon">
                    <img src={RightIcon} alt="" />
                  </div>
                </div>
                <div className="navbar-dropmenu-items">
                  <div className="dropmenu-icon">
                    {/* <img src="" alt="" /> */}
                  </div>
                  <div className="dropmenu-text">Terms and Conditions</div>
                  <div className="dropmenu-rightIcon">
                    <img src={RightIcon} alt="" />
                  </div>
                </div>
                <div className="navbar-dropmenu-items">
                  <div className="dropmenu-icon">
                    {/* <img src="" alt="" /> */}
                  </div>
                  <div className="dropmenu-text">Settings</div>
                  <div className="dropmenu-rightIcon">
                    <img src={RightIcon} alt="" />
                  </div>
                </div>
                <div className="navbar-dropmenu-items">
                  <div className="dropmenu-icon">
                    {/* <img src="" alt="" /> */}
                  </div>
                  <div className="dropmenu-text">
                     <button className="btn" style={{"color":"white"}} onClick={logoutUser}>Logout</button>
                  </div>
                  <div className="dropmenu-rightIcon">
                    <img src={RightIcon} alt="" />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
